import {
  getLinkedOrganizationLimitMessage,
  getMaxLinkedOrganizations,
} from "../config/appSettings.js";

const getAccountKey = (account = {}) =>
  (account?.oid ||
    account?.Oid ||
    account?.emailId ||
    account?.EmailId ||
    account?.email ||
    "")
    .toString()
    .toLowerCase();

export const countLinkedOrganizations = (accounts = []) => {
  const map = new Map();
  (Array.isArray(accounts) ? accounts : []).forEach((account) => {
    const key = getAccountKey(account);
    if (key) map.set(key, account);
  });
  return map.size;
};

export const isOrganizationAlreadyLinked = (accounts = [], incomingAccount = {}) => {
  const incomingKey = getAccountKey(incomingAccount);
  if (!incomingKey) return false;

  return (Array.isArray(accounts) ? accounts : []).some(
    (account) => getAccountKey(account) === incomingKey
  );
};

export const canAddLinkedOrganization = (
  accounts = [],
  limit = getMaxLinkedOrganizations()
) => countLinkedOrganizations(accounts) < limit;

export const wouldExceedLinkedOrganizationLimit = (
  accounts = [],
  incomingAccount = {},
  limit = getMaxLinkedOrganizations()
) => {
  if (isOrganizationAlreadyLinked(accounts, incomingAccount)) {
    return false;
  }

  return countLinkedOrganizations(accounts) >= limit;
};

export const getLinkedOrganizationLimitValidationMessage = () =>
  getLinkedOrganizationLimitMessage();
